import React, {useRef} from 'react';
import {
  registerReactComponent
} from '@trp-beacon-ui-kit/foundation/react/register';
import {
  BeaconButton
} from '@trp-beacon-ui-kit/foundation/components/beacon-button';
// This is the name of your project, library, application, etc. - make sure to use a specific prefix
const projectNamePrefix = 'rmd';

//This is your React component that can be used in the return/render block below
const RMDBeaconButton = registerReactComponent(
  projectNamePrefix,
  BeaconButton
);

const ButtonBeacon = ({ id, label, variant = 'primary', disabled, onClick }) => {
  const rmdButton = useRef();
  return (
    <div class="app-component">
      <RMDBeaconButton
        ref={rmdButton}
        id={id}
        label={label}
        variant={variant}
        disabled={disabled}
        onClick={onClick}
      />
    </div>
  );
};

export default ButtonBeacon;
